import React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useGridApiContext, gridFilteredSortedRowEntriesSelector } from '@mui/x-data-grid';
import { useStore } from 'src/stores';
export const ResidenciesCheckElement = observer(_ref => {
  let disabled = _ref.disabled,
    data = _ref.data,
    rows = _ref.rows;
  const store = useStore();
  // Rendered inside the DataGrid (header/cell), so the grid api context is available.
  const apiRef = useGridApiContext();

  // Select-all must operate on the rows the user actually sees, i.e. after the
  // column filter — not the raw (unfiltered) `rows` prop. Otherwise selecting
  // "all" while a filter hides every row still selects hidden rows and the batch
  // bar shows a nonzero count. Fall back to `rows` if the api is unavailable.
  const getSelectableRows = () => {
    try {
      return gridFilteredSortedRowEntriesSelector(apiRef).map(entry => entry.model);
    } catch (_unused) {
      return rows;
    }
  };
  return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    onChange: () => {
      if (rows && rows.length) {
        if (store.residenciesMultiActionStore.selectedDetails.length) {
          store.residenciesMultiActionStore.deselectAll();
        } else {
          store.residenciesMultiActionStore.selectAll(getSelectableRows());
        }
        return;
      }
      if (store.residenciesMultiActionStore.selectedDetails.findIndex(i => i.id === data.id) === -1) {
        store.residenciesMultiActionStore.setSelectedDetails(data);
      } else {
        store.residenciesMultiActionStore.desetSelectedDetails(data.id);
      }
    },
    disabled: disabled,
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: rows && rows.length ? !!store.residenciesMultiActionStore.selectedDetails.length : store.residenciesMultiActionStore.selectedDetails.findIndex(i => i.id === data.id) > -1
    })
  }));
});